class AppStorage {
  private Storage: Storage;

  constructor() {
    this.Storage = localStorage;
  }

  get(key: string): string | null {
    const value = this.Storage.getItem(key);
    return value;
  }

  set(key: string, value: string): void {
    this.Storage.setItem(key, value);
  }
}

export default AppStorage;
